import { z } from 'zod';
import { uuidSchema } from './common.js';
/**
 * The "Today" strip on Start (D-151 Batch 3) — a read-only aggregation of what needs the category
 * manager today, computed server-side over the existing tenant-scoped services: contracts near their
 * notice cliff, unvalidated bank details, reviews due, suppliers without a score this month, and open
 * erasure requests. Demo rows are excluded: this strip is about YOUR day, not the demo walkthrough.
 */
export const todayItemSchema = z.object({
    id: uuidSchema,
    label: z.string(),
    sub: z.string().nullable(),
});
export const todaySectionSchema = z.object({
    count: z.number(),
    items: z.array(todayItemSchema), // the top few, for display; count carries the total
});
export const todayViewSchema = z.object({
    contractsNearNotice: todaySectionSchema,
    bankNotValidated: todaySectionSchema,
    reviewsDue: todaySectionSchema,
    scorecardsMissingThisMonth: todaySectionSchema,
    erasureRequests: todaySectionSchema,
});
//# sourceMappingURL=today.js.map